import { render, staticRenderFns } from "./IceSelect.vue?vue&type=template&id=587bfa20&"
import script from "./IceSelect.vue?vue&type=script&lang=js&"
export * from "./IceSelect.vue?vue&type=script&lang=js&"
import style0 from "./IceSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports